import sectionProductReviews06Css from '../css-snippets/section-product-reviews-06';

const html = `
<style>${sectionProductReviews06Css}</style>
<div
  class="product-reviews-wrapper product-reviews-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="product-reviews-container"
  style="background-color: #ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <div class="wrap-product-reviews">
      <div
        class="review-overview"
        data-attribute="review-overview"
        style="background-color: #ffffff"
      >
        <div class="review-stats" data-attribute="review-stats">
          <div class="rating-summary" data-attribute="rating-summary">
            <div class="rating-score" data-attribute="rating-score">5</div>
            <div
              class="wrap-stars"
              data-full-stars="5"
              data-attribute="wrap-stars"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                ></path>
              </svg>
            </div>
            <div
              class="reviewers-count-container"
              data-attribute="reviewers-count-container"
            >
              <span class="reviewers-count" data-attribute="reviewers-count">
                3
              </span>
              reviews
            </div>
          </div>
          <table class="rate-list" data-attribute="rate-list">
            <tbody>
              <tr class="rate-item" data-rate-value="5">
                <td class="rate-value">5</td>
                <td class="rate-star">
                  <svg viewBox="0 0 24 24">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                  </svg>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: 100%"></div>
                  </div>
                </td>
                <td class="rate-count">10</td>
              </tr>
          
              <tr class="rate-item" data-rate-value="4">
                <td class="rate-value">4</td>
                <td class="rate-star">
                  <svg viewBox="0 0 24 24">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                  </svg>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: 0%"></div>
                  </div>
                </td>
                <td class="rate-count">0</td>
              </tr>
          
              <tr class="rate-item" data-rate-value="3">
                <td class="rate-value">3</td>
                <td class="rate-star">
                  <svg viewBox="0 0 24 24">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                  </svg>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: 0%"></div>
                  </div>
                </td>
                <td class="rate-count">0</td>
              </tr>
          
              <tr class="rate-item" data-rate-value="2">
                <td class="rate-value">2</td>
                <td class="rate-star">
                  <svg viewBox="0 0 24 24">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                  </svg>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: 0%"></div>
                  </div>
                </td>
                <td class="rate-count">0</td>
              </tr>
          
              <tr class="rate-item" data-rate-value="1">
                <td class="rate-value">1</td>
                <td class="rate-star">
                  <svg viewBox="0 0 24 24">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                  </svg>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: 0%"></div>
                  </div>
                </td>
                <td class="rate-count">0</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="customer-images-container"
          data-attribute="customer-images-container"
        >
          <div class="customer-images" data-attribute="customer-images">
            <div
              class="customer-images-title"
              data-attribute="customer-images-title"
            >
              Customer Photos
            </div>
            <div class="customer-images-grid" data-attribute="customer-images-grid">
            </div>
          </div>
          <button
            type="button"
            class="button-write-review"
            data-attribute="button-write-review"
          >
            Write a review
          </button>
        </div>
      </div>
      <div class="reviews-list">
        <div class="reviews-container"></div>
      </div>
    </div>
  </div>
</div>

<div
  onclick="window.closeImageModal()"
  class="modal-preview-image"
  style="display: none"
>
  <div onclick="event.stopPropagation()" class="modal-preview-image-content">
    <img loading="lazy" data-attribute="modal-preview-image" src="" alt="" />
    <button
      type="button"
      class="close-modal-preview-image"
      data-attribute="close-modal-preview-image"
      onclick="window.closeImageModal()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>
</div>
`;
export default html;
